/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { staffUploadPictureRequestSchema } from "./staffUploadPictureRequestSchema.ts";
import { staffUploadPictureSchema } from "./staffUploadPictureSchema.ts";

export const orgOrganizationStaffUploadPictureCreatePathOrganizationIdSchema = z.uuid();

export const orgOrganizationStaffUploadPictureCreatePathStaffIdSchema = z.uuid();

export const orgOrganizationStaffUploadPictureCreateStatus200Schema = staffUploadPictureSchema;

export const orgOrganizationStaffUploadPictureCreateResponseSchema = orgOrganizationStaffUploadPictureCreateStatus200Schema;

export const orgOrganizationStaffUploadPictureCreateDataSchemaFormData = staffUploadPictureRequestSchema;

export const orgOrganizationStaffUploadPictureCreateDataSchemaFormUrlEncoded = staffUploadPictureRequestSchema;

export const orgOrganizationStaffUploadPictureCreateDataSchema = z.union([
	orgOrganizationStaffUploadPictureCreateDataSchemaFormData,
	orgOrganizationStaffUploadPictureCreateDataSchemaFormUrlEncoded,
]);
